import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  gallery: {
    padding: '20px 16px',
    display: 'flex',
    flexDirection: 'column',
    rowGap: 16
  }
})

export default useStyles
